module.exports = __webpack_public_path__ + "img/JourneySelect1.17877846.jpg";